import type { IFilterOptions, IOptions } from "@fluidattacks/design";
import _ from "lodash";

const getNewFilter = <T extends object>(
  filters: IFilterOptions<T>[],
  key: keyof T,
): IFilterOptions<T> | undefined => {
  const relevantFilter = filters.find((filter): boolean => filter.key === key);

  return relevantFilter;
};

const getCheckedFilter = <T extends object>(
  filters: IFilterOptions<T>[],
  key: keyof T,
): IOptions | undefined => {
  const relevantFilter = getNewFilter(filters, key)?.options?.find(
    ({ checked }): boolean => checked ?? false,
  );

  return relevantFilter;
};

const getCheckedFilters = <T extends object>(
  filters: IFilterOptions<T>[],
  key: keyof T,
): string[] | undefined => {
  const relevantFilters = getNewFilter(filters, key)
    ?.options?.filter(({ checked }): boolean => checked ?? false)
    .map(({ value }): string => value);

  return relevantFilters;
};

const getDateRangeFilter = <T extends object>(
  filters: IFilterOptions<T>[],
  key: keyof T,
): { from: string | undefined; to: string | undefined } => {
  const filter = getNewFilter(filters, key);

  return {
    from:
      _.isEmpty(filter?.minValue) && _.isNil(filter?.minValue)
        ? undefined
        : String(filter?.minValue),
    to:
      _.isEmpty(filter?.maxValue) && _.isNil(filter?.maxValue)
        ? undefined
        : String(filter?.maxValue),
  };
};

const getNumberRangeFilter = <T extends object>(
  filters: IFilterOptions<T>[],
  key: keyof T,
): { max: number | undefined; min: number | undefined } => {
  const filter = getNewFilter(filters, key);

  return {
    max:
      _.isEmpty(filter?.maxValue) && typeof filter?.maxValue !== "number"
        ? undefined
        : Number(filter?.maxValue),
    min:
      _.isEmpty(filter?.minValue) && typeof filter?.minValue !== "number"
        ? undefined
        : Number(filter?.minValue),
  };
};

export {
  getDateRangeFilter,
  getNumberRangeFilter,
  getNewFilter,
  getCheckedFilter,
  getCheckedFilters,
};
